module.exports = __webpack_public_path__ + "media/images/icons/country_flags/hk-8b89a0a3a4b2b0fe24c4a2b4aa7495b2.svg";